module.exports = __webpack_public_path__ + "img/passion.d7e488f5.svg";